module.exports = __webpack_public_path__ + "img/totally-radio-90s.ca14accd.png";